import styled from 'styled-components';

export const ProfileSvg = styled.svg`
    height: 100%;
`;
